export const PAY = '[Pay]'

export const POST_PAY = `${PAY} Post`
export const SET_SIV_ERROR = 'SET_SIV_ERROR';
export const CLEAR_SIV_ERROR = 'CLEAR_SIV_ERROR';

export const setSivError = (error = true) => ({
    type: SET_SIV_ERROR,
    payload: error
});

export const clearSivError = () => ({
    type: CLEAR_SIV_ERROR
});
export const postPay = ({query, form, url_pay}) => ({
    type: POST_PAY,
    payload: {
        data: query,
        body: {...form, ...url_pay}
    },
})